module.exports = __webpack_public_path__ + "fonts/iconfont.dd6aaf4.eot";